var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mt-20 fs-14 text-center"},[_c('div',{staticClass:"text-9b mt-10"},[_vm._v("增值电信业务经营许可证: 京B2-20213935")]),_c('div',{staticClass:"mt-10"},[_c('a',{staticClass:"text-9b",attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("京ICP备16007160号 ")])])])])
}]

export { render, staticRenderFns }